// Single source of truth for the Services mega-menu (desktop columns and the
// mobile drawer, via src/data/siteNav.js). Grouped by what the visitor is
// trying to get done, every item a distinct live page: URLs that only
// redirect to another entry (grow-your-agency, top-rated-ghl-experts-teams,
// ghl-crm-workflow-automation-for-agencies, white-label-ghl-services-for-
// agencies) are deliberately left out.
//
// `description` on each category and item is the one-line copy shown in the
// desktop panel. Keep item copy under ~65 characters so it fits two lines.

export const SERVICE_MENU = [
  {
    category: 'Set Up GoHighLevel',
    description: 'Get your account built right from day one',
    items: [
      { label: 'GHL Setup & Configuration', description: 'Sub-accounts, pipelines, calendars and phone setup done right', to: '/services/ghl-setup' },
      { label: 'GHL Snapshots', description: 'Reusable account templates for faster launches', to: '/services/ghl-snapshots' },
      { label: 'SaaS CRM Launch', description: 'Launch GoHighLevel SaaS Mode as your own branded CRM', to: '/services/saas-crm' },
      { label: 'A2P Compliance', description: 'Brand and campaign registration so your texts get delivered', to: '/services/a2p-compliance' },
    ],
  },
  {
    category: 'Automate & Grow',
    description: 'Automation, AI and connected tools',
    items: [
      { label: 'Workflow Automation', description: 'Follow-up, booking and pipeline automation that runs 24/7', to: '/services/automation' },
      { label: 'AI Agent Builder', description: 'AI agents for support, lead qualification and booking', to: '/services/ai-agent-builder' },
      { label: 'Voice AI', description: 'Voice agents that answer calls, qualify leads and book', to: '/services/voice-ai' },
      { label: 'API Integrations', description: 'Webhooks, Zapier, Make and custom platform connections', to: '/services/api-integrations' },
      { label: 'GHL Ads Management', description: 'Meta and Google ads wired into GoHighLevel follow-up', to: '/services/ghl-ads-management' },
    ],
  },
  {
    category: 'Custom Development',
    description: 'Custom software, apps and APIs',
    items: [
      { label: 'Vibe Coding & Custom Dev', description: "Custom tools and dashboards GoHighLevel can't build natively", to: '/services/vibe-coding' },
      { label: 'GHL API & Custom Development', description: 'Custom apps and extensions on the GoHighLevel API', to: '/services/ghl-api-custom-development' },
      { label: 'Custom SaaS Development', description: 'SaaS products designed and built from scratch', to: '/services/custom-saas-development' },
      { label: 'App Development', description: 'Web and mobile apps built around your workflow', to: '/services/app-development' },
      { label: 'Figma to Code', description: 'Designs turned into production-ready code', to: '/services/figma-to-code' },
    ],
  },
  {
    category: 'Ongoing Support',
    description: 'A team on call after launch',
    items: [
      { label: 'White-Label Support', description: '24/7 GoHighLevel help delivered under your agency brand', to: '/services/white-label-support' },
      { label: 'SaaS Customer Support', description: 'Customer service for SaaS businesses and their users', to: '/services/saas-customer-support' },
      { label: 'Dedicated GHL Team', description: 'Certified GoHighLevel experts without the cost of hiring', to: '/services/cost-effective-ghl-team' },
      { label: 'Expert Team for Agencies', description: 'A GoHighLevel team that works as part of your agency', to: '/services/ghl-experts-for-agencies' },
    ],
  },
]
